import React from 'react';
import './App.scss';
import 'common/plugins/toast/react-toast-mobile.scss';
import Dialog, {T} from 'react-toast-mobile';
import Router from 'common/components/Router';
import PayPanel from 'common/components/pay-panel/PayPanel';
import PayResultTips from 'common/components/pop-tips/PayResultTips';
import Queue from 'common/js/queue';
import loginUtils from 'common/js/login';
import Toast from 'common/components/toast/Toast';
import utils from 'common/js/utils';
import pubsub from 'common/js/pubsub';
import conf from 'common/js/conf';
import Login from 'views/login/Login';

export default class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            source: 'home',
            isShowPayTips: false,
            isShowTopupPanel: false,
            tipsInfo: {},
            showCallAppToast: false,
	        isShowLogin: false
        }
        this.timerPayTips = null;
	    this.payCloseQueue = new Queue();

        this.showPayTips = this.showPayTips.bind(this);
        this.closePayTips = this.closePayTips.bind(this);
        this.showPayPanel = this.showPayPanel.bind(this);
        this.closePayPanel = this.closePayPanel.bind(this);
	    this.closeLoginPanel = this.closeLoginPanel.bind(this);
	    this.showLoginPanel = this.showLoginPanel.bind(this);
	    this.addClosePayCallback = this.addClosePayCallback.bind(this);

	    pubsub.subscribe('hideLogin', this.closeLoginPanel);
	    pubsub.subscribe('showLogin', this.showLoginPanel);
	    pubsub.subscribe('showReg', this.showRegPanel);

        // 存储来:识别登录来源，便于直播间的goBack
        var sHref = window.location.href;
        if(sHref.indexOf('#redirectlogin') > -1) {
            conf.referrer = 'login';
            // 替换地址栏显示的地址
            window.history.replaceState && window.history.replaceState(window.history.state, '', sHref.replace(/#redirectlogin/g, ''));
        }

	    if(sHref.indexOf('#redirectwxpay') > -1) {
		    // 替换地址栏显示的地址
		    window.history.replaceState && window.history.replaceState(window.history.state, '', sHref.replace(/#redirectwxpay/g, ''));
		    this.redirect = 'wxpay';
	    }

    }

    componentDidMount(){
        var self = this;
        this._mounted = true;

	    if(this.redirect && this.redirect === 'wxpay') {
		    T.confirm({
			    title: '',
			    message: `<p>请确认微信支付是否已完成</p>`,
			    option: [{
				    text: '已完成支付',
				    fn: () => window.location.reload()
			    }, {
				    text: '关闭'
			    }]
		    });
	    }
        pubsub.subscribe('openApp', function(type, msg) {
            clearTimeout(self.openAppTimer);
            if(msg === 'success') {
                self.setState({
                    showCallAppToast: true
                });
                self.openAppTimer = setTimeout( ()=>{
                        if( self._mounted ){
                            self.setState({
                                showCallAppToast: false
                            });
                        }
                },3000)
            }
        });

	    pubsub.subscribe('hideLogin', this.closeLoginPanel);
	    pubsub.subscribe('showLogin', this.showLoginPanel);
    }

    componentWillUnmount() {
        this._mounted = false;
    }

	/**
	 * 添加关闭支付弹窗回调事件
	 */
	addClosePayCallback(fn){
		this.payCloseQueue.add(fn);
	}

    /**
     * 关闭支付弹窗
     */
    closePayPanel(e) {
        e && e.stopPropagation();
        this.setState({
            isShowTopupPanel: false
        });
	    this.payCloseQueue.run();
	    this.payCloseQueue.clear();
    }

    /**
     * 显示支付弹窗
     * @param title {String} 弹窗标题
     */
    showPayPanel(args={}) {
        if(loginUtils.toLogin()) {
            this.topupTitle = args.title || '';
            this.setState({
                isShowTopupPanel: true,
                source: args.source ? args.source : 'home'
            });
        }
    }

    /**
     * 显示支付结果弹窗
     * @param info {Object} 内容配置
     */
    showPayTips(info, callback) {
        this.setState({
            isShowPayTips: true,
            tipsInfo: info
        });

        if(info.type === 'suc'){
            // 发布成功支付的消息
            pubsub.publish("pay", 'success');
        }

        this.timerPayTips = setTimeout(function() {
	        this.closePayTips();
	        callback && callback();
        }.bind(this), 3000);
    }

    /**
     * 隐藏支付结果弹窗
     */
    closePayTips() {
        this.setState({
            isShowPayTips: false
        });

        clearTimeout(this.timerPayTips);
    }

	/**
	 * 关闭登录弹窗
	 */
	closeLoginPanel() {
		this._mounted && this.setState({
			isShowLogin: false
		});
		loginUtils.clearCallback();
	}

	/**
	 * 显示登录弹窗
	 */
	showLoginPanel() {
		this._mounted && this.setState({
			isShowLogin: true
		});
	}

    render() {
        const state = this.state;
        const oProps = {
            fShowPayPanel: this.showPayPanel,
            fShowPayTips: this.showPayTips,
            fClosePayPanel: this.closePayPanel,
            fClosePayTips: this.closePayTips,
	        fAddClosePayCallback: this.addClosePayCallback
        };

        return (
            <div className="g-wrap">
                <Router {...oProps} />
                {state.isShowPayTips === true ?
                    <PayResultTips
                        oTipsInfo={state.tipsInfo}
                        fClose={this.closePayTips}/> : ''}
                {state.isShowTopupPanel ?
                    <PayPanel
                        source={state.source}
                        fClose={this.closePayPanel}
                        fShowPayTips={oProps.fShowPayTips}
                        topupTitle={this.topupTitle}/> : ''}
                {state.showCallAppToast?
                    <Toast msg='正在打开app...'/>:
                    null
                }
	            {state.isShowLogin ? <Login /> : ''}
                <div className="dialog-modal"><Dialog /></div>
           </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/app/App.js